/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Switch } from "@/components/ui/switch";
import { DropdownMenuArrow } from "@radix-ui/react-dropdown-menu";
import { EllipsisVertical } from "lucide-react";
import { useState } from "react";

export const VoidDocumentList = ({ row, onAction, disabled }: any) => {
  const status = row?.originData?.state;
  const isVoid = row?.originData?.is_void;
  const [isPending, setIsPending] = useState(false);

  const onCheckedChange = async (checked: boolean) => {
    setIsPending(true);
    await onAction({
      action: "void",
      data: { doc_id: row?.originData?.doc_id, is_void: checked },
    });
    setIsPending(false);
  };

  return (
    <DropdownMenu>
      {["on_hold", "void", "erp_failed", "snc_success"].includes(status) ? (
        <DropdownMenuTrigger
          disabled={disabled}
          className="disabled:opacity-50"
        >
          <button className="outline-none! border-0! focus-visible:outline-none focus-visible:border-0 text-primary pt-1.5">
            <EllipsisVertical size={18} />
          </button>
        </DropdownMenuTrigger>
      ) : (
        <button className="outline-none! border-0! focus-visible:outline-none focus-visible:border-0 opacity-0 pt-1.5">
          <EllipsisVertical size={18} />
        </button>
      )}

      <DropdownMenuContent className="dark w-40 bg-black" align="end">
        <DropdownMenuArrow className="fill-black" />
        <div className="flex items-center gap-2 px-2 py-1.5 text-sm">
          <Switch
            checked={isVoid ? true : false}
            disabled={isPending || disabled}
            onCheckedChange={onCheckedChange}
            className="data-[state=unchecked]:bg-zinc-600 [&>span]:bg-white"
          />
          <span>Mark as Void</span>
        </div>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
